<template>
  <div class="page-left">
    <div class="menuBox">
      <template v-for="(item, index) in menuList">
        <div
          :key="'item-' + index"
          class="menu-item"
          :class="{ active: isActive(item) }"
          @click="handleClick(item)"
        >
          <span class="menu-label">{{ item.name }}</span>
          <span v-if="item.children && item.children.length" class="menu-arrow">
            <i :class="['el-icon-arrow-right', { expanded: isExpanded(item) }]"></i>
          </span>
        </div>

        <div
          v-if="item.children && item.children.length && isExpanded(item)"
          :key="'sub-' + index"
          class="submenu"
        >
          <div
            v-for="(child, cIndex) in item.children"
            :key="cIndex"
            class="submenu-item"
            :class="{ active: active === child.index }"
            @click="handleOpen(child.index)"
          >
            <span>{{ child.name }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const defaultMenuList = [
  { name: "工作台", index: "work" },
  {
    name: "我的融资",
    index: "financing",
    children: [
      { name: "融资交易", index: "trading" },
      { name: "我的融资需求", index: "financingNeeds" },
    ],
  },
  {
    name: "我的信用",
    index: "credit",
    children: [{ name: "我的信用评分", index: "grade" }],
  },
  {
    name: "企业信息",
    index: "enterprise",
    children: [
      { name: "基本信息", index: "basic" },
      { name: "我的授权", index: "accredit" },
      { name: "账号安全", index: "security" },
    ],
  },
  { name: "我的消息", index: "message" },
];

export default {
  name: "menuList",
  props: {
    menuList: {
      type: Array,
      default: () => defaultMenuList,
    },
  },
  data() {
    return {
      active: "work",
      expandedIndex: null,
    };
  },
  created() {
    this.syncActive();
  },
  methods: {
    /** 判断菜单项是否激活 */
    isActive(item) {
      return this.active === item.index;
    },

    /** 判断子菜单是否展开 */
    isExpanded(item) {
      const idx = this.menuList.indexOf(item);
      return idx === this.expandedIndex;
    },

    /** 点击菜单项 */
    handleClick(item) {
      if (item.children && item.children.length) {
        const idx = this.menuList.indexOf(item);
        this.expandedIndex = this.expandedIndex === idx ? null : idx;
      } else {
        this.handleOpen(item.index);
      }
    },

    /** 路由跳转 */
    handleOpen(index) {
      this.active = index;
      this.$router.push({ name: index });
    },

    /** 根据路由同步激活状态 */
    syncActive() {
      if (this.$route.name) {
        this.active = this.$route.name;
        this.menuList.forEach((item, idx) => {
          if (item.children && item.children.some((c) => c.index === this.active)) {
            this.expandedIndex = idx;
          }
        });
      }
    },
  },
  watch: {
    $route(to) {
      this.active = to.name;
      this.menuList.forEach((item, idx) => {
        if (item.children && item.children.some((c) => c.index === to.name)) {
          this.expandedIndex = idx;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page-left {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  box-sizing: border-box;
}

.menuBox {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: white;
  padding:10px  10px 0 10px;
  border-radius: 8px;
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 12px 20px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 10px;
}

.menu-item.active {
  // background: #ffffff;
  // box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.menu-label {
  font-family: "PingFang SC", sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}

.menu-item.active .menu-label {
  color: #1366ec;
  font-weight: 600;
}

.menu-arrow {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
}

.menu-arrow .expanded {
  transform: rotate(90deg);
}

.submenu {
  padding-left: 20px;
  margin-top: -2px;
  margin-bottom: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.submenu-item {
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-family: "PingFang SC", sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  transition: all 0.3s;
}

.submenu-item:hover {
  background: rgba(255, 255, 255, 0.6);
}

.submenu-item.active {
  // background: #ffffff;
  color: #1366ec;
  // font-weight: 600;
  // box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
</style>

